import { render, staticRenderFns } from "./VideoTutorial.vue?vue&type=template&id=e90edbba&scoped=true&"
import script from "./VideoTutorial.vue?vue&type=script&lang=ts&"
export * from "./VideoTutorial.vue?vue&type=script&lang=ts&"
import style0 from "./VideoTutorial.vue?vue&type=style&index=0&id=e90edbba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90edbba",
  null
  
)

export default component.exports